import { LogoutIcon } from 'tdesign-icons-vue-next';
import { shallowRef } from 'vue';
import { RouteRecordRaw } from 'vue-router';

export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录页',
      icon: shallowRef(LogoutIcon),
    },
    component: () => import('@/layouts/blank-layout.vue'),
    children: [
      {
        path: 'index',
        component: () => import('@/layouts/blank-layout.vue'),
        meta: {
          title: '登录页',
        },
      },
    ],
  },
] as RouteRecordRaw[];
